import { ProjectFuzeID } from '@models/interfaces';

export const PROJECT_FUZE_ID_SUM_DEFAULT_VALUE: ProjectFuzeID = {
  id: undefined,
  fuzeID: undefined,
  PSProjectNumber: undefined,
  projectAssignedDate: undefined,
  RFPriority: undefined,
};
